import get from "lodash/get";
import React from "react";
import compose from "lodash/flowRight";
import {withRouter} from "react-router-dom";
import {useTranslation} from "@unibuddy/intl";
import {rootURL} from "../../../Utils/WhereAmI";
import RequestPasswordReset from "../../../PasswordReset/containers/RequestPasswordReset/RequestPasswordReset";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {getenv} from "../../../../util/getEnv";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_RESET_REQUEST} from "../../../../translations/passwordReset";

const RequestPasswordResetLayout = (props) => {
    const onix = props.isOnix;
    const THEME_PRIMARY = getenv("THEME_PRIMARY");
    const themePrimary = onix ? THEME_PRIMARY : get(props, "university.colour", THEME_PRIMARY);
    const loginLink = `${rootURL(props.location.pathname)}/auth/login`;
    const {t, i18n} = useTranslation(IntlNamespaces.PASSWORD_RESET);

    return (
        <div>
            <PageTitle title={t(INTL_RESET_REQUEST.key, INTL_RESET_REQUEST.defaultValue)} />
            <RequestPasswordReset
                currentLocale={i18n.language || undefined}
                themePrimary={themePrimary}
                loginLink={loginLink}
                redirectUrl={get(props.location, "state.redirectUrl", "")}
                /* This is not grabbing an environment variable */
                rootUrl="ONIX_URL"
                universitySlug={get(props, "universitySlug", "")}
            />
        </div>
    );
};

export default compose(withRouter)(RequestPasswordResetLayout);
